import Axios from "axios";
import QueryString from "qs";
import MgpStore from "Stores/Store";
const { v4: uuidv4 } = require("uuid");
// MgpStore.subscribe(() => MgpStore.getState());


export const FileApiInstance = Axios.create({
    baseURL:process.env.REACT_APP_MGP_BASE_URL,
    withCredentials: true,
    headers:{
        'Content-Type': 'multipart/form-data',
    },
});
const kstOffset = 1000 * 60 * 60 * 9
// FileApiInstance.interceptors.request.use (
//     (config) => {
//         config.data.apiHdr =  {
//             lang:MgpStore.getState().LangSetState.Lang,
//             rqstDtime:new Date(Date.now() + kstOffset).toISOString(),
//             timeZone:Intl.DateTimeFormat().resolvedOptions().timeZone,
//             timeZoneGmt:new Date().toTimeString().slice(9),
//             rqstTrxId:uuidv4(),
//         }
//         return config;
//     },
//     (error) => {
        
//         console.log(error.config.data.message);
//         throw new Error(error.config.data.message);
        
//     }
// );

FileApiInstance.interceptors.response.use(
    response => {
      return response;
    },
    error => {
        // if (error.response && error.response.status === 401) {
        //     // 401 Unauthorized 에러 처리
        // } else if (error.response && error.response.status === 404) {
        //     // 404 Not Found 에러 처리
        // } else if (error.response && error.response.status === 500) {
        //     // 500 Internal Server Error 에러 처리
        // } else if (error.response && error.response.status === 403) {
            
        // } 
        // else if (error.response && error.response.status === 503) {
           
        // }else {
        //     // 기타 에러 처리
        // }
        const errorUrl = "/Error?error_cd="+error.response.status;
        //  return window.location.href = errorUrl;
        return Promise.reject(error);
    }
);



const MembQnaRegApi = async (
    gameSvcCd:string,
    prntQnaSno:string,
    qnaKindCd:string,
    qnaCtgrCd:string,
    qnaTitl:string,
    qnaCtxt:string,
    file:File|undefined,
    cptchTkn?: string,
) => {
    const formData = new FormData();
    const data = {
        apiHdr:{
            lang:MgpStore.getState().LangSetState.Lang,
            rqstDtime:new Date(Date.now() + kstOffset).toISOString(),
            timeZone:Intl.DateTimeFormat().resolvedOptions().timeZone,
            timeZoneGmt:new Date().toTimeString().slice(9),
            rqstTrxId:uuidv4(),
        },
        apiBody:{
            prntQnaSno:prntQnaSno,
            qnaKindCd:qnaKindCd,
            qnaCtgrCd:qnaCtgrCd,
            qnaTitl:qnaTitl,
            qnaCtxt:qnaCtxt,
            cptchTkn: cptchTkn || "",
        },
    }
    if(file) {
        formData.append("file",file)
    }
    formData.append(
        "data",
        new Blob([JSON.stringify(data)],{
            type:"application/json",
        }),
    )
    console.log(formData)



    return await FileApiInstance.post(`memb/qna/${gameSvcCd}/reg`,formData)
    .then((Resp) => Resp.data);
}
export default MembQnaRegApi;